import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, TrendingUpIcon } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="bg-white border-b border-slate-200 sticky top-0 z-50" data-id="element-83">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="flex justify-between h-16" data-id="element-85">
          <div className="flex items-center" data-id="element-86">
            <Link to="/" className="flex items-center gap-2" data-id="element-87">
              <TrendingUpIcon className="text-blue-600" size={28} data-id="element-88" />
              <span className="text-xl font-bold text-slate-900" data-id="element-89">
                CryptoTopReviews
              </span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-90">
            <Link to="/cryptocurrencies" className="text-slate-700 hover:text-blue-600 font-medium transition-colors" data-id="element-91">
              Cryptocurrencies
            </Link>
            <Link to="/exchanges" className="text-slate-700 hover:text-blue-600 font-medium transition-colors" data-id="element-92">
              Exchanges
            </Link>
            <Link to="/opportunities" className="text-slate-700 hover:text-blue-600 font-medium transition-colors" data-id="element-93">
              Opportunities
            </Link>
            <Link to="/social-media" className="text-slate-700 hover:text-blue-600 font-medium transition-colors" data-id="element-94">
              Social Media
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-95">
            <button onClick={() => setIsOpen(!isOpen)} className="text-slate-700 hover:text-blue-600" data-id="element-96">
              {isOpen ? <XIcon size={24} data-id="element-97" /> : <MenuIcon size={24} data-id="element-98" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden border-t border-slate-200" data-id="element-99">
          <div className="px-2 pt-2 pb-3 space-y-1" data-id="element-100">
            <Link to="/cryptocurrencies" className="block px-3 py-2 text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md font-medium" onClick={() => setIsOpen(false)} data-id="element-101">
              Cryptocurrencies
            </Link>
            <Link to="/exchanges" className="block px-3 py-2 text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md font-medium" onClick={() => setIsOpen(false)} data-id="element-102">
              Exchanges
            </Link>
            <Link to="/opportunities" className="block px-3 py-2 text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md font-medium" onClick={() => setIsOpen(false)} data-id="element-103">
              Opportunities
            </Link>
            <Link to="/social-media" className="block px-3 py-2 text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md font-medium" onClick={() => setIsOpen(false)} data-id="element-104">
              Social Media
            </Link>
          </div>
        </div>}
    </nav>;
}